import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Container, Button, Box } from '@mui/material';
import DataTable from 'react-data-table-component';
import Header from '../components/Headers/Header';
import { customStyles } from '../utils/tableStyleFOrAllOrders';
import useGlobalStyles from '../utils/globalStyles';
import { orderCustomStyles } from '../utils/tableForOutFOrDeliveryReportDetails';
import CustomLoader from '../components/Loader/CustomLoader';

const AutoAssignRiderResultPage = (props) => {
  const { t } = props;
  const globalClasses = useGlobalStyles();
  const autoAssignRiderResults = JSON.parse(localStorage.getItem("autoAssignRiderResults"));
  const [loading, setLoading] = useState(false); // Still unused, but not the cause of this data issue

  // These are now directly the arrays of order objects
  const assigned = autoAssignRiderResults && autoAssignRiderResults.assignedOrders ? autoAssignRiderResults.assignedOrders : [];
  const unassigned = autoAssignRiderResults && autoAssignRiderResults.unassignedOrders ? autoAssignRiderResults.unassignedOrders : [];

  // Flatten the across all riders - NO LONGER NEEDED TO 'FLATTEN' IN THIS WAY
  // The 'assigned' variable is ALREADY a flat array of order objects.
  // We can just assign it directly.
  const assignedOrders = assigned; // <<<--- SIMPLIFY THIS LINE

  // You can still log to confirm:
  console.log('Flattened assignedOrders for display (CORRECTED):', assignedOrders);

  // Function to convert the deliveryDate into ISO format (this is fine)
  function convertToISO(deliveryDateString) {
    // ... (your existing function) ...
  }

 const orderColumns = [
  { name: 'Order ID', selector: row => row._id, cell: (row) => <>{row._id.slice(-5)}</> },
  {
    name: 'Customer Name',
    selector: row => row.customerName || 'NA', // Corrected: direct property
    style: { cursor: 'pointer', minWidth: "150px" },
  },
  {
    name: 'Customer Phone',
    selector: row => row.customerPhone || 'NA', // Corrected: direct property
    style: { cursor: 'pointer', minWidth: "150px" },
  },
  {
    name: 'Delivery Date',
    selector: 'deliveryDate',
    cell: (row) => <>{row.deliveryDate}</>, // Keep this simple for now, or reintroduce conversion if needed and working
  },
  {
    name: "Delivery Address",
    sortable: false,
    cell: row => {
      const deliveryAddress = row.deliveryAddress;
      const details = deliveryAddress && deliveryAddress.details ? deliveryAddress.details : "NA";
      const address = deliveryAddress && deliveryAddress.deliveryAddress ? deliveryAddress.deliveryAddress : "NA";
      return <>{`${details}, ${address}`}</>;
    },
    style: { cursor: 'pointer', minWidth: "300px", textAlign: 'left' },
  },
  {
    name: 'Locked Rider',
    selector: row => row.lockedRiderEmail || 'Not Assigned', // Corrected: direct property (added by frontend)
    style: { minWidth: "200px" },
  },
  { name: 'Amount', selector: row => row.orderAmount },
];
  const downloadCSV = () => {
    const csvRows = [];
    const headers = ['Order ID', 'Customer Name','Customer Phone', 'Delivery Date', 'Delivery Address', 'Order Amount', 'Locked Rider Email'];


    const escapeCsvValue = (value) => {
      if (!value) return 'N/A';
      return `"${value.replace(/"/g, '""')}"`;
    };

    csvRows.push('Assigned Orders');
    csvRows.push(headers.join(','));

    if (assignedOrders.length) {
      assignedOrders.forEach(order => {
        const row = [
          order._id,
          order.customerName || 'N/A',
          order.customerPhone || 'N/A',
          escapeCsvValue(order.deliveryDate),
          escapeCsvValue(`${order.deliveryAddress.details}, ${order.deliveryAddress.deliveryAddress}`),
          order.orderAmount || 'N/A',
          order.lockedRiderEmail || 'N/A'
        ];
        csvRows.push(row.join(','));
      });
    }

    csvRows.push('');
    csvRows.push('Unassigned Orders');
    csvRows.push(headers.join(','));

if (unassigned && unassigned.length){
   unassigned.forEach(order => {
        const row = [
          order._id,
          order.customerName || 'N/A',
          order.customerPhone || 'N/A',
          escapeCsvValue(order.deliveryDate),
          escapeCsvValue(`${order.deliveryAddress.details}, ${order.deliveryAddress.deliveryAddress}`),
          order.orderAmount || 'N/A',
          order.lockedRiderEmail  || 'N/A'
          
        ];
        csvRows.push(row.join(','));
      });
    }

    const csvContent = `data:text/csv;charset=utf-8,${csvRows.join('\n')}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'assigned_and_unassigned_orders.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleback = () => {
    props.history.push('/local_admin/Manageriders');
    localStorage.removeItem('autoAssignRiderResults');
  };

  return (
    <>
      <Header />
      <Container className={globalClasses.flex} fluid>
        <Box sx={{ textAlign: 'right', mb: 3 }}>
          <Button onClick={downloadCSV} className={globalClasses.dashbordBtn}>Download CSV</Button>
          <Button onClick={handleback} className={globalClasses.dashbordBtn}>Back</Button>
        </Box>

        {loading ? (
          <CustomLoader />
        ) :  autoAssignRiderResults ? (
          <>
            <br />
            <DataTable
              keyField="_id" 
              customStyles={orderCustomStyles}
              title="Assigned Orders"
              columns={orderColumns}
              data={assignedOrders} // Use flattened assigned orders data
              pagination
            />
            <br />
            <DataTable
              customStyles={orderCustomStyles}
              title="Unassigned Orders"
              columns={orderColumns}
             data={unassigned}
              pagination
            />
          </>
        ) : (
          <p>No order details found.</p>
        )}
      </Container>
    </>
  );
};

export default withTranslation()(AutoAssignRiderResultPage);
